<template>
  <v-container class="main-container responsive-height">
    <v-row>
      <v-col
        v-for="(platform, index) in platformsList"
        :key="index"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card
          class="elevation-0 rounded-0 platform-card text-center"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
        >
          <v-img
            :src="getPlatformIcon(platform.type)"
            max-width="140"
            height="140"
            class="mx-auto"
          ></v-img>
          <v-card-title>Server: {{ platform.server_name }}</v-card-title>
          <v-btn
            link
            outlined
            @click="openExternalLink(platform.download_link)"
            tile
            >Free Download</v-btn
          >
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PLATFORMS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  name: "platformView",
  computed: {
    ...mapState("platform", ["platforms"]),
    platformsList() {
      const platform = this.platforms[0] || {};
      return [
        {
          type: 'android',
          server_name: platform.server_name || 'Production Server',
          download_link: platform.android_download_link
        },
        {
          type: 'windows',
          server_name: platform.server_name || 'Production Server',
          download_link: platform.windows_download_link
        },
        {
          type: 'ios',
          server_name: platform.server_name || 'Production Server',
          download_link: platform.ios_download_link
        }
      ];
    }
  },
  methods: {
    ...mapActions("platform", [PLATFORMS__ACTIONS.DOWNLOADPLATFORMS]),
    openExternalLink(url) {
      window.open(url, "_blank");
    },
    getPlatformIcon(type) {
      const icons = {
        android: require("../../assets/android.png"),
        windows: require("../../assets/windows.png"),
        ios: require("../../assets/apple.png")
      };
      return icons[type];
    }
  },
  async mounted() {
    try {
      await this[PLATFORMS__ACTIONS.DOWNLOADPLATFORMS]();
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style scoped>
.platform-card {
  transition: all 0.3s ease;
}
</style>